<template>
  <div class="chord-graph-container mb-5 mt-5">
    <div class="container-viz pt-5 pb-5 text-white">
        <div class="container-graph">
            <div class="row justify-content-center">
              <div class="col-12 col-md-8 col-lg-7 mb-3">
                <h2 class="graph-title">
                  Informantes, opinantes y desinformantes
                </h2>
                <div>
                  <p class="bajada-graph">
                    En el ecosistema digital político de la capital peruana se refunde una maraña desinformadora que, con más fuerza desde la derecha, refuerza su presencia para las elecciones presidenciales de 2026.
                  </p>
                </div>
              </div>
              <div class="col-12 col-md-11 col-lg-7 col-xl-7">
                <div class="legends-level mb-3">
                  <div class="mb-2">Nivel de desinformación: </div>
                  <div class="mb-1 d-flex legend-s">
                    <div><span class="legend-box" style="
                      background: #ffeda1;
                  "></span> Bajo </div>
                    <div><span class="ml-3 legend-box" style="
                      background: #fd8d3c;
                  "></span> Medio </div>
                    <div><span class="ml-3 legend-box" style="
                      background: #e41a1c;
                  "></span> Alto </div>
                  </div>
                </div>
                <div id="chord-diagram"></div>
                <div class="text-left d-sm-block d-md-none">
                  <div class="d-flex">

                    <div class="legend-item">
                      <span class="mr-1 legend-box" style="
                        background: #1550c8;
                    "></span> Universidad San Ignacio de Loyola
                    </div>

                    <div class="legend-item">
                      <span class="mr-1 legend-box" style="
                        background: #fb9a99;
                    "></span> Vectores desinformantes
                    </div>


                    <div class="legend-item">
                      <span class="mr-1 legend-box" style="
                        background: #33a02c;
                    "></span> Tradicional con versión digital
                    </div>

                    <div class="legend-item">
                      <span class="mr-1 legend-box" style="
                        background: #ca70c2;
                    "></span> Nativos digitales
                    </div>
                    

                  </div>
                 <div class="d-flex">
                 

                  <div class="legend-item">
                    <span class="mr-1 legend-box" style="
                      background: #a6cee3;
                  "></span> Mayor alcance en redes sociales
                  </div>

                  <div class="legend-item">
                    <span class="mr-1 legend-box" style="
                      background: #33FFFF;
                  "></span> Medio de izquierda
                  </div>

                  <div class="legend-item">
                    <span class="mr-1 legend-box" style="
                      background: #e3e3e3;
                  "></span> Medio de derecha
                  </div>
                 </div>


                </div>
              </div>
              <div class="col-12 col-md-8">
                <div class="small border-top pt-2 mt-3 mb-3 text-right">                  
                  Análisis de datos: Jazmin Bianchi |
                  Fuente: El Foco.  
                </div>
                <div class="small text-right">
                  <a class="text-info" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                    Leer nota metodológica
                  </a>
                </div>
                <div class="collapse metodologia mt-3" id="collapseExample">
                  <ol>
                    <li>
                      Los “vectores de desinformación” son elementos que propagan información falsa o engañosa en la red. Estos pueden incluir personas, cuentas de redes sociales, sitios web o medios que difunden contenido erróneo o malicioso.
                    </li>
                    <li>
                      Los medios y actores analizados fueron directamente por <strong>EL FOCO</strong> fueron El Reporte, Piensa.pe, ILAD Media, La Abeja, Tiempo 26/Suriel Chacón, Willax, Expreso, La Razón, PBO, Canal B, El Montonero, Lampadia; Los Amautas, Chasqui TV, Rimac Llaqta, Ecos Latinos, Aníbal Stacio,  Timoteo Cutipa, Asociación Cultural Ágora Popular de la Plaza San Martín e Inty Noticias (izquierda). 
                    </li>
                    <li>
                      No todos los medios y actores se consideran desinformantes; varios fueron descartados en el curso de la investigación.
                    </li>
                    <li>
                      Para los medios de izquierda nos apoyamos en la investigación realizada por el investigador Camilo Ferreira del Centro Wiñaq.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<style lang="scss">
  .chord-graph-container {
    background-color: #000;
    background-image: url('../assets/bg-graph.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .container-graph {
    width: 100%;
    max-width: 1220px;
    padding: 0 15px;
    margin: 0 auto;
  }

  .tooltip {
    background: #fff;
    pointer-events: none;
    max-width: 320px;
    padding: 10px;
    font-family: "Noto Sans";
    opacity: 1;
    display: none;
    font-size: 14px !important;

    &.active {
      display: block;
    }

    .high {
      background-color: #e41a1c;
      color: #fff;
    }

    .medium {
      background-color: #fd8d3c;
      color: #000;
    }

    .low {
      background-color: #ffeda1;
      color: #000;
    }
  }

  .legend-item {
    display: inline-block;
    width: 140px;
    font-size: 13px;
    text-align: left;
    margin: 10px;
  }

  .legend-box {
    width: 16px;
    min-width: 16px;
    height: 16px;
    min-height: 16px;
    margin: 0 0px 0 0;
    display: inline-block;
  }

  .metodologia {
    padding: 20px;
    background-color: #000;

    strong {
      font-weight: 800;
    }

    li {
      margin-bottom: 15px;
      font-size: 16px;
      text-align: left;
    }
  }

  .legends-level {
    position: absolute;
    right: 0;
    top: -5px;
    text-align: right;
    font-size: 13px;
    font-weight: 600;
    color: #ffffff;
    background: #ffffff17;
    padding: 5px 15px;

    @media screen and (max-width: 767px) {
      position: relative;
      top: 0px;
      text-align: center;
      font-size: 15px;
      padding: 10px 0;
    
      .legend-s {
        justify-content: center;    
      }
    }
  }

  h2.graph-title {
    font-size: 31px;
    color: #fff;
    font-family: "Fira Sans",sans-serif;
  }

  .bajada-graph {
    font-family: "Lora" !important;
    color: #e3e3e3 !important;
    line-height: 1.6em;
    font-size: 19px;
  }

  .label-category {
    @media screen and (max-width: 720px) {
      display: none;
    }
  }
  
</style>

<script>


import * as d3 from 'd3'

export default {
  name: 'ChordMedias',
  data() {
    return {
      url_path: `/wp-content/themes/oceanwp/especiales/el-cartel-de-la-desinformacion`,
      current_year: '2003',
      show_bar: false,
      analytics: [],
      width: 640,
      height: 600,
      radius: 200,
      radiusB: 220
    }
  },
  mounted() {
    setTimeout(() => {
      let container_width = document.querySelector(`#chord-diagram`).offsetWidth
      this.width = container_width *.99
      this.radius = this.width / 3.3,
      this.radiusB = this.width / 2.7

      if(this.width <= this.height) {
        this.height = this.width * 1.1

        if(window.innerWidth <= 620) {
          this.height = this.width
        }
      }

      this.renderGraph()

    }, 100)
  },
  methods: {
    wrap(text, width) {
      text.each(function() {
        var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineHeight = 1.1, // ems
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em")

        while (words.length > 0) {
          word = words.pop()
          line.push(word);
          tspan.text(line.join(" "));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(" "));
            line = [word];
            tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", lineHeight + "em").text(word)
          }
        }
      });
    },
    renderGraph() {
      const data = require(`@/data/media_network.json`)

        // Extract unique media names and categories
        const mediaLogos = [...new Set(data.map(d => d.media_logo))];
        const mediaNames = [...new Set(data.map(d => d.media_name))];
        const categories = [...new Set(data.map(d => d.categories))];

        // Create nodes array (media + categories)
        const nodes = [...mediaNames, ...categories];

        // Create matrix
        const matrix = [];
        for (let i = 0; i < nodes.length; i++) {
            matrix[i] = new Array(nodes.length).fill(0);
        }

        // Fill matrix with connections
        data.forEach(item => {
            const mediaIndex = nodes.indexOf(item.media_name);
            const categoryIndex = nodes.indexOf(item.categories);
            matrix[mediaIndex][categoryIndex] += 1;
            matrix[categoryIndex][mediaIndex] += 1;
        });

        const svg = d3.select("#chord-diagram")
            .append("svg")
            .attr("width", this.width)
            .attr("height", this.height)
            .append("g")
            .attr("transform", `translate(${this.width/2},${this.height/1.9})`);

        // Generate the chord layout
        const chord = d3.chord()
            .padAngle(0.12)
            .sortSubgroups(d3.descending);

        const chords = chord(matrix);
        // Color scales

        const desinformationColor = d3.scaleOrdinal()
            .domain(["low", "medium", "high"])
            .range(["#ffeda0","#fd8d3c", "#e41a1c"]);

        const categoryColor = d3.scaleOrdinal()
            .domain(["Mayor alcance en redes sociales", "Nativo Digital","Tradicional con versión digital","Vectores desinformantes", "Universidad San Ignacio de Loyola", "Medio de derecha", "Medio de izquierda"])
            .range(["#e3e3e3", "#33FFFF","#a6cee3","#ca70c2", "#33a02c", "#fb9a99", "#1550c8"]);

        // Add the groups (nodes)
        const group = svg.append("g")
            .selectAll("g")
            .data(chords.groups)
            .join("g");

        const arc = d3.arc()
            .innerRadius(this.radius)
            .outerRadius(this.radiusB);

        group.append("path")
            .attr("fill", (d, i) => {
                if (i < mediaNames.length) {
                    const mediaInfo = data.find(item => item.media_name === nodes[i]);
                    return desinformationColor(mediaInfo.desinformation_level);
                } else {
                    return categoryColor(i - mediaNames.length);
                }
            })
            .attr("d", arc);

        // Add logos for media outlets
        group.filter((d, i) => i < mediaNames.length)
            .append("g")
            .attr("transform", d => {
                const [x, y] = arc.centroid(d);
                return `translate(${x * 1.15},${y * 1.15})`;
            })
            .each(function(d) {
                const logo = d3.select(this).append("g")

                logo
                .append('g')
                  .append('image')
                    .attr('xlink:href', `/wp-content/themes/oceanwp/especiales/el-cartel-de-la-desinformacion/logos/${mediaLogos[d.index]}.png`)
                    .attr('transform', `translate(-15,-15)`)
                    .attr('width', 30)
                    .attr('height', 30)
            });

        // Add the chords (connections)
        const ribbons = svg.append("g")
            .attr("fill-opacity", 0.67)
            .selectAll("path")
            .data(chords)
            .join("path")
            .attr("d", d3.ribbon().radius(this.radius))
            .attr("fill", d => {
              
                if (d.source.index < mediaNames.length) {
                    const mediaInfo = data.find(item => item.media_name === nodes[d.source.index]);
                    return desinformationColor(mediaInfo.desinformation_level);
                } else {
                    return categoryColor(d.source.index - mediaNames.length);
                }
            })

        // Add labels for categories
        group.filter((d, i) => i >= mediaNames.length)
            .append("text")
            .each(d => { d.angle = (d.startAngle + d.endAngle) / 2; })
            .attr("dy", ".35em")
            .attr("transform", d => `
                rotate(${(d.angle * 180 / Math.PI - 90)})
                translate(${this.radius * 1.05},10)
                ${d.angle > Math.PI ? "rotate(180)" : ""}
            `)
            .attr("text-anchor", d => d.angle > Math.PI ? "end" : null)
            .text((d, i) => (categories[i]))
            .attr("class", "label-category")
            .style("font-size", "14px")
            .style("fill", "white")
            .style("text-shadow", "1px 1px 1px #000")
            .call(this.wrap, 95);

        // Add tooltip
        const tooltip = d3.select("body").append("div")
            .attr("class", "tooltip")
            .style("opacity", 0);

        // Add hover effects
        group.on("mouseover", function(event, d) {
            const isMedia = d.index < mediaNames.length;
            
            // Highlight the hovered group
            d3.select(this).select("path").attr("fill", "white");

            // Dim all ribbons
            ribbons.attr("opacity", 0.1);

            // Highlight connected ribbons
            ribbons.filter(r => r.source.index === d.index || r.target.index === d.index)
                .attr("opacity", 1)
                .attr("fill", "white");

            // Show tooltip
            tooltip.transition()
                .duration(200)
                .style("opacity", .9)
                .style("display",`block`);
            
            if (isMedia) {
                const mediaInfo = data.find(item => item.media_name === nodes[d.index]);
                let text = `
                <strong>
                  ${mediaInfo.media_name}
                </strong><br/>
                <div><span class="${(mediaInfo.desinformation_level)}">${mediaInfo.desinformation_label}</span></div>
                <div>${mediaInfo.political_spectrum}</div>`

                if(mediaInfo.media_owner_director) {
                  text += `<div class="d-flex mt-1">`
                    
                  if(mediaInfo.owner_director_picture) {
                    text +=`<div><img width="60px" class="d-inline mr-2 " src="/wp-content/themes/oceanwp/especiales/el-cartel-de-la-desinformacion/owners/${mediaInfo.owner_director_picture}.jpg" /></div>`
                  }
                  
                  text += `<div><b>${mediaInfo.owner_director}:</b> <br />${mediaInfo.media_owner_director} </div></div>`
                }
                
                tooltip.html(text)
            } else {
                const category = nodes[d.index];
                const relatedMedia = data.filter(m => m.categories === category).map(m => ({
                    name: m.media_name,
                    spectrum: m.political_spectrum
                }));
                const uniqueRelatedMedia = Array.from(new Set(relatedMedia.map(m => JSON.stringify(m))))
                    .map(m => JSON.parse(m));
                tooltip.html(`<strong>${category}</strong><br/>
                              Medios relacionados: ${uniqueRelatedMedia.length}`)
            }
            
            tooltip.style("left", (event.pageX + 10) + "px")
                   .style("top", (event.pageY - 28) + "px");
        })
        .on("mouseout", function(event, d) {
            const isMedia = d.index < mediaNames.length;
            
            // Restore original colors
            d3.select(this).select("path")
                .attr("fill", isMedia ? 
                    desinformationColor(data.find(item => item.media_name === nodes[d.index]).desinformation_level) : 
                    categoryColor(d.index - mediaNames.length));

            // Restore all ribbons
            ribbons.attr("opacity", 0.67)
                .attr("fill", d => {
                    if (d.source.index < mediaNames.length) {
                        const mediaInfo = data.find(item => item.media_name === nodes[d.source.index]);
                        return desinformationColor(mediaInfo.desinformation_level);
                    } else {
                        return categoryColor(d.source.index - mediaNames.length);
                    }
                });

            // Hide tooltip
            tooltip.transition()
                .duration(500)
                .style("opacity", 0)
                .style("display", `none`);
        });

    }
  }
  
}
</script>